query getOnboardingMarkets {
  getOnboardingMarkets
}